import { $api } from '@service/RequestService';
import { buildingEndpoints } from '@utils/constants/apis';
import { useQuery } from 'react-query';
import { NumberParam, useQueryParam } from 'use-query-params';

import { Block, blockSchema } from 'modules/shaxmatka';

import { BLOCK } from '../keys';

interface Params {
  houseId: number;
}

interface IQuery {
  blocks: Block[];
}

export const useBlocks = ({ houseId }: Params) => {
  const [blockId, setBlockId] = useQueryParam('blockId', NumberParam);

  const initialValue = { blocks: [] };

  const { data = initialValue, ...args } = useQuery<IQuery>(
    BLOCK.list({ houseId }).queryKey,
    async () => {
      const { data } = await $api.get(buildingEndpoints.INDEX, { params: { houseId } });

      const blocks: Block[] = (data.data || []).map(blockSchema.parse);

      return { blocks };
    },
    {
      enabled: !!houseId,
      onSuccess: ({ blocks }) => {
        const block = blocks.find(block => block.id === blockId);

        setBlockId(block?.id || blocks[0]?.id || undefined);
      }
    }
  );

  return { ...data, ...args };
};
